import {Injectable} from '@angular/core';
import {FilterControl} from "../interface/filter-control";
import {ActivatedRoute, Params} from "@angular/router";
import {ColorFilterItem} from "../interface/color-filter-item";
import {NormalFilterControl} from "../interface/normal-filter-control";
import {NormalFilterItem} from "../interface/normal-filter-item";
import {RangeFilterControl} from "../interface/range-filter-control";
import {SegmentCategoryControl} from "../interface/segment-category-control";
import {SubCategoryControls} from "../interface/sub-category-controls";

@Injectable({
    providedIn: 'root'
})
export class FilterUrlDecoderService {

    constructor(
        private _activatedRoute: ActivatedRoute,
    ) {
    }

    public decodeUrlAndChangeFilter(controls: FilterControl): FilterControl {

        let queryParam: Params = this._activatedRoute.snapshot.queryParams;

		// debugger
        // console.log(queryParam);
        // console.log(controls);

        for (let [key, value] of Object.entries(queryParam)) {

            if (key.includes('segment-')) {
                let keyName: string = key.replace('segment-', '')
                let paramSubCatValue:  string[] = decodeURIComponent(queryParam[key]).split(',');


                controls.nestedControls.forEach((control: SegmentCategoryControl): void => {
                    if (keyName === control.name) {

                        paramSubCatValue.forEach((urlSubCatName: string): void => {

                            control.options.forEach((option: SubCategoryControls): void => {
                                if(urlSubCatName===option.name) {
                                    option.activated = true;
                                }
                            });

							if(urlSubCatName==='all') {
								control.options.forEach((option: SubCategoryControls): void => {
									option.activated = true;
								})
							}
                        })
                    }
                })

            }

        }

        // console.log(controls)


        if (queryParam['Colours']) {

            let colors: string | string[] = decodeURIComponent(queryParam['Colours']);
            colors = colors.split(',');

            colors.forEach((urlColor: string): void => {

                controls.colorFilterControls[0].options.forEach((color: ColorFilterItem): void => {

                    if (color.name === urlColor) {
                        color.activated = true;
                    }
                })
            })
        }

        // normal filter control start
        for (let [key, value] of Object.entries(queryParam)) {

            controls.normalFilterControls.forEach((normalFilterControl: NormalFilterControl) => {

                if (key === normalFilterControl.name) {

                    let decodeValues: string[] = decodeURIComponent(queryParam[key]).split(',');

                    decodeValues.forEach((decodeValue: string, i: number) => {

                        normalFilterControl.options.forEach((option: NormalFilterItem) => {
                            if (decodeValue === option.name) option.activated = true;
                        })
                    })

                }
            })
        }
        // normal filter control end


        for (let [key, value] of Object.entries(queryParam)) {

            if (key === 'Availability' || key === 'GSM' || key === 'Price') {

                value = decodeURIComponent(value).split(',');
                let minQTY = value[0].replace('min-', '');
                let maxQTY = value[1].replace('max-', '');

                controls.rangeFilterControls.forEach((rangeFilterControl: RangeFilterControl): void => {
                    if (rangeFilterControl.name === key) {

                        rangeFilterControl.values.min = +minQTY;
                        rangeFilterControl.values.value1 = +minQTY;
                        rangeFilterControl.values.value2 = +maxQTY;
                        rangeFilterControl.values.max = +maxQTY;
                    }
                })
            }
        }

        if (queryParam['Instock']) {
            controls.singleFilterControls[0].options = queryParam['Instock'] === 'true';

        }


        console.log(controls);
        return controls;
    }
}
